import { Component, inject, OnInit } from '@angular/core';
import { ISettingsConfigComponent } from '../../models/util/settingsConfig';
import { AuthService } from '../../services/auth/auth.service';
import { MaterialModule } from '../../material/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { FormsModule } from '@angular/forms';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PaymentService } from '../../services/payment/payment.service';
import { PaymentMethod } from '../../models/paymentMethod';
import { CreditCardTypeComponent } from "../../shared/credit-card-type/credit-card-type.component";
import { CreditCardItemComponent } from '../../shared/credit-card-item/credit-card-item.component';

@Component({
	selector: 'app-settings-payment-method',
	standalone: true,
	imports: [
    MaterialModule,
    PipesModule,
    FormsModule,
    NgxSkeletonLoaderModule,
    CreditCardTypeComponent,
	CreditCardItemComponent
],
	templateUrl: './settings-payment-method.component.html',
	styleUrl: './settings-payment-method.component.scss'
})
export class SettingsPaymentMethodComponent implements ISettingsConfigComponent, OnInit {

	private readonly authService = inject(AuthService);
	private readonly paymentService = inject(PaymentService);

	user = this.authService.auth.user;
	paymentMethods: PaymentMethod[] = [];
	paymentMethodExpiration: string[] = [];
	loading: boolean = false;

	async ngOnInit(): Promise<void> {
		this.paymentMethods = await this.getMyPaymentMethods();
	}

	async getMyPaymentMethods(): Promise<PaymentMethod[]> {
		this.loading = true;
		let result: PaymentMethod[] = [];
		try {
			result = await this.paymentService.getPaymentMethodsByUserId(this.user?.id);
		} catch (error) {}
		this.loading = false;
		return result;
	}

	hasDataChanged(): boolean {
		return false;
	}

	async paymentMethodDeletedCb(): Promise<void> {
		this.loading = true;
		this.paymentMethods = await this.getMyPaymentMethods();
		this.loading = false;
	}

}
